export class AppSyncExecutionTimeoutError extends Error {
}